<template>
    <span v-if="ticket && ticket.orderId && 'TicketTitle' == field">
        <TicketTitle style="overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"
          :ticketTitle="ticket.orderTitle"
          :ticketNo="ticket.orderId"
          target="_blank"/>
    </span>
    <span v-else-if="ticket && ticket.orderId">{{ticket[field]}}</span>
    <span v-else>没有</span>
</template>

<script>
export default {
    name : 'UserLatestTicket',

    props : [ 'value', 'field'],

    data() {
        return {
            ticket : {}
        }
    },

    watch : {
        value() {
            this.loadData();
        },

        field() {
            this.loadData();
        }
    },

    methods : {
        loadData() {
            var _this = this;

            sdk.TicketApi().list({
                filter : { $eq : { creatorId : _this.value }} ,
                page : { pageSize : 1, orderBy : '`create_time` DESC' }
            }).then(res => {
                if ( !!res && !!res.list && res.list.length > 0 ) {
                    _this.ticket = res.list[0];

                    _this.$emit('loadTicket', _this.ticket);

                    return;
                }

                _this.ticket = {};
                console.log('#27 res', res, _this.value, _this);
            });
        }
    },

    mounted() {
        this.loadData();
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/UserLatestTicket.vue